/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-associated-control */

import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Drawer, Loader } from 'rsuite';
import PropTypes from 'prop-types';
import { getModuloById } from '../../services/treinamentos';
import EditorModuloAula from './EditorModuloAula';
import EditorModuloQuiz from './EditorModuloQuiz';

function EditorModulo({ showEditorModulos, setShowEditorModulos, idModulo, idTreinamentoModulos, setShowModulos }) {
  const moduloId = idModulo;
  // const { moduloId } = useParams();
  const [loading, setLoading] = useState(true);
  const [tipoModulo, setTipoModulo] = useState(null);

  useEffect(() => {
    const loadModulo = async () => {
      try {
        const data = await getModuloById(moduloId);
        setTipoModulo(data.tipo);
      } catch (error) {
        console.error('Erro ao carregar módulo:', error);
      } finally {
        setLoading(false);
      }
    };

    loadModulo();
  }, [moduloId]);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        width: '100%'
      }}>
        <Loader size="lg" content="Carregando..." />
      </div>
    );
  }

  if (tipoModulo === 'quiz') {
    return (
      <Drawer
        full
        open={showEditorModulos}
        onClose={() => setShowEditorModulos(false)}
      >
        <EditorModuloQuiz setShowModulos={setShowModulos} idModulo={idModulo} setShowEditorModulos={setShowEditorModulos} showEditorModulos={showEditorModulos} idTreinamentoModulos={idTreinamentoModulos} />
      </Drawer>
    )
    }
  
  return (
    <Drawer
      full
      open={showEditorModulos}
      onClose={() => setShowEditorModulos(false)}
    >
     <EditorModuloAula setShowModulos={setShowModulos} idModulo={idModulo} setShowEditorModulos={setShowEditorModulos} showEditorModulos={showEditorModulos} idTreinamentoModulos={idTreinamentoModulos} />
    </Drawer>
  )
}


EditorModulo.propTypes = {
  showEditorModulos: PropTypes.bool.isRequired,
  setShowEditorModulos: PropTypes.func.isRequired,
  idModulo: PropTypes.number.isRequired,
  idTreinamentoModulos: PropTypes.number.isRequired,
  setShowModulos: PropTypes.func.isRequired,
};

export default EditorModulo;
